import { ca } from '@cian/analytics';
import { adAnalyticsCategory } from '../../../scripts/services/analytics.service';

export const trackReportAddressModalOpen = () => {
  ca('event', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'AddressIssuesPopupOpen',
    label: '',
  });
};

export const trackNextButtonClick = ({ label, analyticsProduct, selectedRegionId, formId }) => {
  ca('eventSite', {
    name: 'oldevent',
    category: adAnalyticsCategory,
    action: 'address_step',
    label,
    products: [analyticsProduct],
    page: {
      pageType: 'AddForm',
      extra: {
        selectedRegionId,
        formId,
      },
    },
  });
};
